<template>
  <v-app @click="handleIdleTime">

    <v-app v-if="!themeLoaded" v-resize="onResize" id="app">
      <v-content fluid pa-0>
        Loading...
      </v-content>
    </v-app>

    <v-app v-else-if="themeLoaded && isAuthenticated && user" v-resize="onResize" id="app">

      <v-navigation-drawer
        v-model="drawer.model"
        :clipped="drawer.clipped"
        :floating="drawer.floating"
        :mini-variant="drawer.mini"
        :permanent="drawer.type === 'permanent'"
        :temporary="drawer.type === 'temporary'"
        app
        absolute
        color="primary"
        :dark="theme.textOnDark"
      >
        <v-list nav >
          <v-list-item v-if="$vuetify.breakpoint.xsOnly" to="/" class="py-2">
            <img
              :src="theme.logoImgUrl"
              contain
              max-width="224"
              max-height="52"
              position="center center"
            />
          </v-list-item>

          <v-divider v-if="$vuetify.breakpoint.xsOnly"></v-divider>

          <div v-for="item in items" :key="item.title">

            <!-- simple item -->
            <div v-if="!item.items">
              <v-list-item v-if="verifyPerm(item)" @click="handleItemClick(item)">
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>

                <v-list-item-title>{{item.title}}</v-list-item-title>
              </v-list-item>
            </div>

            <!-- item group -->
            <div v-else>
              <div v-if="verifyPerm(item)">
                <v-list-group
                  v-model="item.active"
                  :prepend-icon="item.icon"
                  :append-icon="(!item.items) ? null : '$expand'"
                  no-action
                  color="secondary"
                >
                  <template v-slot:activator >
                    <v-list-item-content @click="handleItemClick(item)">
                      <v-list-item-title v-text="item.title"></v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <div v-for="subItem in item.items" :key="subItem.title" >
                    <div v-if="verifyPerm(item)">
                      <v-list-item
                        @click="handleItemClick(subItem)"
                      >
                        <v-list-item-title v-text="subItem.title"></v-list-item-title>
                        <v-list-item-icon>
                          <v-icon>{{subItem.icon}}</v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                    </div>
                  </div>

                </v-list-group>
              </div>
            </div>
          </div>
        </v-list>
      </v-navigation-drawer>
      <!-- App bar -->
      <v-app-bar :clipped-left="drawer.clipped" app :key="theme.updatedAt">
        <!-- Menu icon and Logo -->
        <v-app-bar-nav-icon
          v-if="drawer.type !== 'permanent'"
          @click.stop="drawer.model = !drawer.model"
        ></v-app-bar-nav-icon>

        <v-img
          v-if="$vuetify.breakpoint.smAndUp"
          :src="theme.logoImgUrl"
          to="/"
          contain
          max-width="200"
          max-height="65"
          aspect-ratio="1.5"
          position="center center"
        />

        <!-- src="@/assets/mb-logo.svg" -->

        <v-spacer></v-spacer>

        <div class="blue-grey--text" :class="[$vuetify.breakpoint.xsOnly ? 'caption' : 'body-1']">
          {{ $route.meta.desc }}
        </div>

        <v-spacer></v-spacer>
        <!-- Left icons -->
        <div>
          <v-badge overlap left class="pr-5">
            <template v-slot:badge>0</template>
            <v-icon>mdi-bell-outline</v-icon>
          </v-badge>
          <!-- <v-btn icon class="pr-5">
            <v-icon>mdi-settings-outline</v-icon>
          </v-btn> -->
          <v-menu bottom left nudge-bottom="50">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on">
                <img :src="user.avatar" :key="user.updatedAt" />
              </v-avatar>
            </template>

            <v-list>
              <v-list-item @click="handleProfileMenuClick({ name: 'patientCadastre' })">
                <!-- $router.push({ name: 'patient-cadastre' }) -->
                <v-list-item-title>{{ user.name }}</v-list-item-title>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item
                v-for="(item, i) in profileMenuItems"
                :key="i"
                @click="handleProfileMenuClick(item)"
              >

                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>

              </v-list-item>

            </v-list>
          </v-menu>
        </div>
      </v-app-bar>
      <!-- Content -->
      <v-content>
        <v-container fluid pa-0>
          <router-view />
        </v-container>
      </v-content>
    </v-app>

    <v-app v-else v-resize="onResize" id="app">
      <v-content fluid pa-0>
        <router-view />
      </v-content>
    </v-app>

    <!-- Snackbar -->
    <v-app v-if="snackbar.show">
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" bottom>
        {{ snackbar.message }}
        <v-btn text @click="snackbar.show = false" >Fechar</v-btn>
      </v-snackbar>
    </v-app>

    <!-- Change Password -->
    <v-app v-if="changePasswordDialog">
      <v-dialog v-model="changePasswordDialog" max-width="350" >
        <change-password-card @cancel="changePasswordDialog = false"
          @save="changePasswordDialog = false"/>
      </v-dialog>
    </v-app>

    <!-- Reactivated user -->
    <v-app v-if="isUserActivated">
      <v-dialog v-model="isUserActivated" max-width="400" >
        <v-card>
          <v-card-title class="headline">Prefeito</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-icon size="48">mdi-check-circle-outline</v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="body-1">
                Seja bem vindo. Sentimos sua falta, sua conta acaba de ser reativada.
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="$store.dispatch('auth/updateUserActivated', false)">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>

    <!-- Pre-scheduling -->
    <v-app v-if="showPreScheduleMsg">
      <v-snackbar v-model="showPreScheduleMsg" top vertical :timeout="0">
        <!-- color="red"  -->
        <v-container>
          <v-row class="subtitle-2">Concluir agendamento pendente</v-row>
          <v-row>
            <v-btn text @click="preSchedule" >Agendar</v-btn>
            <v-spacer />
            <v-btn text @click="cancelPreSchedule" >Cancelar</v-btn>
          </v-row>
        </v-container>
      </v-snackbar>
    </v-app>
  </v-app>
</template>

<script>
import bus from '@/plugins/eventBus';
import menu from '@/utils/menu';
import ChangePasswordCard from '@/components/general/ChangePasswordCard';

export default {
  data: () => ({
    drawer: {
      model: true,
      type: 'permanent',
      clipped: true,
      floating: false,
      mini: false,
    },
    items: menu,
    footer: {
      inset: false,
    },
    snackbar: {
      show: false,
      message: null,
      color: 'success',
    },
    changePasswordDialog: false,
    idleTimeTimer: null,
    renewTimer: null,
    preScheduleId: null,
    showPreScheduleMsg: false,
    themeLoaded: false,
  }),
  sockets: {
    connect() {
      this.$socket.client.emit('authenticate', { token: process.env.VUE_APP_SOCKET_SECRET });
    },
    unauthorized() {
      // console.error(`SOCKET - unauthorized`);
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    user() {
      return this.$store.getters['auth/getUser'];
    },
    profileMenuItems() {
      return [
        { name: 'changepass', text: 'Alterar Senha' },
        // { name: "config", text: "Configurações" },
        { name: 'terms', text: 'Termos de Uso' },
        { name: 'privacyPolicy', text: 'Política de Privacidade' },
        { name: 'sair', text: 'Sair' },
      ];
    },
    isUserActivated() {
      return this.$store.getters['auth/isUserActivated'];
    },
    theme() {
      return this.$store.getters['poweredBy/theme'];
    },
  },
  created() {
    this.handlePreSchedule();

    // PoweredBy
    this.handlePoweredBy();

    // Messages
    bus.$on('message', ({ message, type }) => {
      this.snackbar.message = message;
      this.snackbar.color = type;
      this.snackbar.show = true;
    });

    // Renew Token
    bus.$on('login', (expiresIn) => {
      this.handleRenew(expiresIn);
    });

    bus.$on('renew', (expiresIn) => {
      this.handleRenew(expiresIn);
    });

    // Idle time
    this.handleIdleTime();

    // Trata login/logout no caso de utilização de mais de uma aba
    window.onstorage = (e) => {
      // Logout
      if (e.key === 'mblogin' && e.newValue === '0') {
        if (this.renewTimer) clearInterval(this.renewTimer);
        this.$router.push({ name: 'login' });
        this.$store.dispatch('auth/logout');
      }
      // Login
      if (e.key === 'mblogin' && e.newValue === '1') {
        this.$store.dispatch('auth/renew').then(() => {
          this.$router.push({ name: 'home' });
        });
      }
    };
  },
  methods: {
    handlePoweredBy() {
      let th = null;

      if (this.$route.name == null) {
        const uri = window.location.search.substring(1);
        const params = new URLSearchParams(uri);
        th = params.get('th');
      } else if (this.$route.name === 'login') {
        // eslint-disable-next-line prefer-destructuring
        th = this.$route.query.th;
      }

      if (!th && this.$route.name !== 'login') {
        th = this.$store.getters['poweredBy/th'];
      }

      if (!th) th = 'RQjlpyvAe9';

      console.log(`handlePoweredBy th: ${th}`);
      this.$store.dispatch('poweredBy/getTheme', th)
        .then((theme) => {
          this.$vuetify.theme.themes.light = theme.colors;
          this.themeLoaded = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onResize() {
      this.drawer.type = this.$vuetify.breakpoint.mdAndUp
        ? 'permanent'
        : 'temporary';
      this.drawer.clipped = this.$vuetify.breakpoint.mdAndUp;
    },
    handleItemClick(item) {
      if (item.path) {
        if (this.$route.path !== item.path) this.$router.push({ path: item.path });
      }
    },
    handleProfileMenuClick(item) {
      if (item.name === 'patientCadastre') {
        if (this.$route.name !== 'patient-cadastre') {
          this.$router.push({ name: 'patient-cadastre' });
        }
      } else if (item.name === 'changepass') {
        this.changePasswordDialog = true;
      } else if (item.name === 'terms') {
        window.open('https://dev.medibook.com.br/app/terms/term', '_blank');
      } else if (item.name === 'privacyPolicy') {
        window.open('https://dev.medibook.com.br/app/terms/policy', '_blank');
      } else if (item.name === 'sair') {
        this.logout();
      }
    },
    logout() {
      const th = this.$store.getters['poweredBy/th'];

      this.$store
        .dispatch('auth/logout')
        .then(() => {
          this.$router.push({ name: 'login', query: (th) ? { th } : {} });
        })
        .catch((err) => {
          bus.$emit('message', {
            message: err.response.data.message,
            type: 'error',
          });
        });
    },
    handleIdleTime() {
      if (this.idleTimeTimer) clearInterval(this.idleTimeTimer);

      this.idleTimeTimer = setTimeout(() => {
        if (!['register', 'login', 'recover-password'].includes(this.$route.name)) {
          if (this.renewTimer) clearInterval(this.renewTimer);
          this.logout();
        }
      }, Number(process.env.VUE_APP_IDLE_TIME));
    },
    handleRenew(expiresIn) {
      const expire = (Number(expiresIn) * 0.90) * 1000;
      if (this.renewTimer) clearInterval(this.renewTimer);

      this.renewTimer = setTimeout(() => {
        this.$store
          .dispatch('auth/renew')
          .catch((err) => {
            if (err.response.data.message === 'Token inválido') {
              bus.$emit('message', {
                message: 'Por favor, efetue login novamente',
                type: 'error',
              });
              this.logout();
            } else {
              bus.$emit('message', {
                message: err.response.data.message,
                type: 'error',
              });
              this.logout();
            }
          });
      }, expire);
    },
    handlePreSchedule() {
      this.preScheduleId = localStorage.getItem('mbpps');

      this.showPreScheduleMsg = false;

      if (this.preScheduleId && !['login', 'register', 'pre-schedule'].includes(this.$route.name)) {
        this.showPreScheduleMsg = true;
      }
    },
    preSchedule() {
      this.showPreScheduleMsg = false;
      this.$router.push({ name: 'pre-schedule', query: { ps: this.preScheduleId } });
    },
    cancelPreSchedule() {
      this.showPreScheduleMsg = false;
      localStorage.removeItem('mbpps');
      this.preScheduleId = null;
    },
    verifyPerm(item) {
      if (item.product) {
        return item.product == 'poweredby' && this.user.products && this.user.products.includes(item.product);
      }
      return true;
    },
  },
  watch: {
    $route(to, from) {
      this.handlePreSchedule();
    },
  },
  components: {
    ChangePasswordCard,
  },
};
</script>
